import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ItemType } from '../../types/DragAndDrop';
import { SORTABLE_TRANSITION } from '../Trip/DnD/types';
import Card, { CardProps } from './Card';

interface SortableCardProps extends CardProps {}

function SortableCard({
  card,
  listId,
  tripId,
  cardOrder,
  isLarge = false,
  canEdit = false,
  canDelete = false,
  onCardMouseEnter,
  onCardMouseLeave,
}: SortableCardProps) {
  const index = cardOrder?.indexOf(card.id);

  const { setNodeRef, transform, transition, isDragging, listeners, attributes } = useSortable({
    id: card.id,
    data: { type: ItemType.CARD, card, listId, index },
    disabled: !canEdit,
    transition: SORTABLE_TRANSITION,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Translate.toString(transform),
        transition,
        opacity: isDragging ? 0 : undefined,
      }}
      {...listeners}
      {...attributes}
    >
      <Card
        card={card}
        listId={listId}
        tripId={tripId}
        cardOrder={cardOrder}
        isLarge={isLarge}
        canEdit={canEdit}
        canDelete={canDelete}
        onCardMouseEnter={onCardMouseEnter}
        onCardMouseLeave={onCardMouseLeave}
        isPlaygroundCard={true}
      />
    </div>
  );
}

SortableCard.displayName = 'SortableCard';
export default SortableCard;
